import { FIELD_TYPE_INFO } from "./const";

export const getDataTypeIcon = (dataType: string): string => {
  return FIELD_TYPE_INFO[dataType]?.icon ?? "text";
};

export const getDataTypeLabel = (dataType: string): string => {
  return FIELD_TYPE_INFO[dataType]?.label ?? "Campo";
};

/**
 * Icono de una columna de un campo de tipo tabla. Reusa el mapa de tipos de
 * campo porque los tipos de columna son un subconjunto suyo; la excepcion es
 * `switch`, que en la tabla lleva el toggle grande que pide el diseno.
 */
export const getColumnTypeIcon = (columnType: string | undefined): string => {
  if (columnType === "switch") return "toggle-large-on";
  return FIELD_TYPE_INFO[columnType ?? ""]?.icon ?? "text";
};
